module.exports = __webpack_public_path__ + "img/perforaciones_4-3_1536.246503b8.webp";